
import { Component, Vue } from "vue-property-decorator";
import { ILoginInfo } from "@/models/login-info";

@Component({
  components: {}
})
export default class Home extends Vue {
  public userInfo: ILoginInfo | null = null;

  get isShipAdmin() {
    return this.$dataService.actions.Auth.getShipAdmin().length > 0;
  }

  get offline() {
    return this.$dataService.getters.isOffline();
  }

  public mounted() {
    this.userInfo = this.$dataService.actions.Auth.getUserInfo();
  }
}
